// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-popover,.v-popover .trigger{width:100%}.navbar-popover,.navbar-popover *,.navbar-popover * :focus,.navbar-popover :focus{outline:none!important}.navbar-popover-inner{border-radius:5px 10px 10px 5px;border-style:solid;border-color:#414141;border-width:1px;background-color:#303030;height:100vh;width:200px;padding:10px}@-webkit-keyframes fadeInOpacity{0%{opacity:0}to{opacity:1}}@keyframes fadeInOpacity{0%{opacity:0}to{opacity:1}}", ""]);
// Exports
module.exports = exports;
